export const ru = {
    'strategy-description-avg-click': 'Вы получите максимум кликов с учетом заданных вами ограничений',
    'strategy-description-avg-cpa': 'Вы получите максимум целевых визитов на сайт по заданной в Яндекс.Метрике цели',
    'strategy-description-default':
        'Вы получите максимально возможное количество показов, самостоятельно выбрав ограничения ставки, региона и других параметров, которые влияют на показы',
    'strategy-description-roi':
        'Вы получите максимум целевых визитов по заданной в Яндекс.Метрике цели, выдерживая рентабельность инвестиций на заданном вами уровне',
    'strategy-name-avg-click': 'Оптимизация кликов',
    'strategy-name-avg-cpa': 'Оптимизация конверсий',
    'strategy-name-default': 'Ручное управление ставками с оптимизацией',
    'strategy-name-roi': 'Оптимизация рентабельности'
};
